module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.2b8fe1bc.svg";